// extracted by mini-css-extract-plugin
module.exports = {"tasks-list":"Tasklist_tasks-list__3H2xl"};